import { useParams } from 'react-router-dom';

import { ErrorMessage } from '@Components';
import ConfigurationPolicyContainer from './configurationPolicy.container';

const ConfigurationPolicyWrapper = () => {
  const { policyId, type } = useParams();

  if (!policyId || !type) {
    return <ErrorMessage internalMessage="Unable to get configuration policy" />;
  }
  return <ConfigurationPolicyContainer key={`${policyId}-${type}`} policyId={policyId} type={type} />;
};

export default ConfigurationPolicyWrapper;
